import React, { SetStateAction, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Http } from '../../../../../helpers/axois';
import { useSelector } from 'react-redux';
import style from "../solo.module.sass";
import moduleStyle from "../../../common/aiAgents/style.module.scss";
import { Button, Icon, Input, Select } from "antd";
import VariableAcl from './VariableAcl';
import { Popover } from '@headlessui/react';
import { ReactComponent as InfoSvg } from "../../../../../assets/svg/info.svg"
import { ReactComponent as CloseSvg } from "../../../../../assets/svg/solo-chat/close.svg"
import { AppState } from '../../../../../stateManager/store';
import { useSoloJourneyContext } from '../create/SoloJourneyProvider';

type InputVars = {
    key: string
    value: string
    desc?: string
    type?: string
}

type ActionProps = {
    nodeDetail: any
    widgetDrawer: boolean
    form: any[],
    onUpdateProperties: any
    setWidgetDrawer: React.Dispatch<SetStateAction<boolean>>
    showVariableAcl: boolean
    nameCheck: boolean | string
    lock: boolean
    setShowVariableAcl: React.Dispatch<SetStateAction<boolean>>
    elements: any
};

const { Option } = Select

const Action: React.FC<ActionProps> = ({ elements, setShowVariableAcl, lock, nameCheck, showVariableAcl, nodeDetail, widgetDrawer, form, onUpdateProperties, setWidgetDrawer }) => {

    const [required, setRequired] = useState<string[]>([]);
    const [inputVars, setInputVars] = useState<InputVars[]>([])
    const [outputVariable, setOutputVariable] = useState<string>('');
    const [formKey, setFormKey] = useState("")
    const [loading, setLoading] = useState<boolean>(false)
    const [selectedForm, setSelectedForm] = useState(null);
    const [variableAcl, setVariableAcl] = useState({});
    const [nextNode, setNextNode] = useState<string>("")
    const [name, setName] = useState<string>("");
    const [setupActiveTab, setSetupActiveTab] = useState("freeze")
    const [teardownActiveTab, setTeardownActiveTab] = useState("freeze")
    const [nodes, setNodes] = useState<any[]>()
    const { pathname } = useLocation()
    const locationSplit = pathname.split('/');
    const appId = locationSplit[3];
    const currentBranch: any = useSelector((state: AppState) => {
        const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
        return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
    }, (left: any, right: any) => left.branchId === right.branchId)
    const versionId = useSelector((state: AppState) => {
        return appId && state.apps.appVersion[appId].versionId
    })
    const branchId = currentBranch && currentBranch.branchId;
    const { propertyDetails } = nodeDetail?.data || {}
    const { actionNodeProperties, setActionNodeProperties } = useSoloJourneyContext();
    const requestId = useRef<number>(0)

    useEffect(() => {
        if (widgetDrawer && nodeDetail?.data?.propertyDetails) {
            const { responseBind = "", variableAcl = {}, formKey = "", parameters, inputVars = {} } = propertyDetails || {};
            setOutputVariable(responseBind)
            setFormKey(formKey)
            if (formKey) {
                form && form.forEach((f: any) => {
                    if (f.formKey === formKey) {
                        setSelectedForm(f.displayName)
                    }
                })
            } else {
                setSelectedForm(null)
            }
            getActionsLists()
        } else {
            setInputVars([])
            setRequired([])
            setLoading(false)
            setOutputVariable('')
            setFormKey('')
            setSelectedForm(null)
        }
        setName(propertyDetails?.name || nodeDetail?.id);
        setNextNode(nextNodeId())
    }, [nodeDetail.id, widgetDrawer])

    useEffect(() => {
        if (form) {
            form.forEach((f: any) => {
                if (f.displayName === selectedForm) {
                    setFormKey(f.formKey)
                }
            })
        }
    }, [selectedForm])

    useEffect(() => {
        const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail?.id) })
        const targetNodeFind = elements.filter((el: any) => { return (el.target === nextNode) })
        if (findNextNode.length) {
            setNextNode(findNextNode[0].target)
        } else if (findNextNode.length === 0 && targetNodeFind.length === 0) {
            setNextNode("")
        }
        let arr: any = []
        elements.forEach((e: any) => {
            if (e.data && e.data.type && e.data.type !== "start" && e.data.type !== "error" && e.id !== nodeDetail?.id) {
                arr.push(e)
            }
        })
        setNodes(arr)
    }, [elements])

    const nextNodeId = (): string => {
        const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })

        if (findNextNode.length) {
            return (findNextNode[0].target)
        } else {
            return ("")
        }
    }

    const getActionsLists = () => {
        const { actionName, integrationName, inputVars = {} } = nodeDetail?.data?.propertyDetails;
        if (!actionName || !integrationName || showVariableAcl) return;
        if (actionNodeProperties && actionNodeProperties[`${actionName}:${integrationName}`]) {
            const { function: actionFunc } = actionNodeProperties[`${actionName}:${integrationName}`];
            const result: InputVars[] = Object.keys(actionFunc?.parameters?.properties || {}).reduce((acc: InputVars[], curr: string) => {
                return [...acc, { key: curr, value: inputVars[curr], type: actionFunc?.parameters?.properties[curr].type, desc: actionFunc?.parameters?.properties[curr].description }];
            }, []);
            setRequired(actionFunc?.parameters?.required || [])
            setInputVars(widgetDrawer ? result : [])
            ++requestId.current;
        } else {
            const currentRequestId = ++requestId.current;
            setLoading(true);
            Http.get(`/apps/${appId}/actions?actionName=${actionName}&integrationName=${integrationName}&branchId=${branchId}&versionId=${versionId}`).subscribe((res: any) => {
                if (currentRequestId !== requestId.current) return;
                const { function: actionFunc } = res;
                const result: InputVars[] = Object.keys(actionFunc?.parameters?.properties || {}).reduce((acc: InputVars[], curr: string) => {
                    return [...acc, { key: curr, value: inputVars[curr], type: actionFunc?.parameters?.properties[curr].type, desc: actionFunc?.parameters?.properties[curr].description }];
                }, []);
                setActionNodeProperties((prev) => ({
                    ...prev,
                    [`${actionName}:${integrationName}`]: {
                        ...res,
                        actionName: actionFunc.name,
                        integrationName: actionFunc.integration_name
                    }
                }))
                setRequired(actionFunc?.parameters?.required || [])
                setInputVars(widgetDrawer ? result : [])
                setLoading(false)

            }, (err) => {
                console.log({ err })
                setLoading(false)
            })
        }
    }

    const saveChanges = () => {
        const actionProperties = {
            nodeId: nodeDetail.id,
            name: name,
            nextNode,
            idChange: true,
            variableAcl,
            formKey,
            responseBind: outputVariable,
            actionName: nodeDetail?.data?.propertyDetails?.actionName,
            integrationName: nodeDetail?.data?.propertyDetails?.integrationName,
            inputVars: inputVars.reduce((acc: Record<string, string>, curr: { key: string; value: string }) => {
                return { ...acc, [curr.key]: curr.value };
            }, {})
        }
        onUpdateProperties(actionProperties)
        setWidgetDrawer(false)
    }

    const handleInputChange = (key: string, newValue: string) => {
        setInputVars((prevInputvars) =>
            prevInputvars.map((vars) =>
                vars.key === key ? { ...vars, value: newValue } : vars
            )
        );
    };

    return (
        <>
            {!showVariableAcl ?
                <>
                    <div style={{ display: "flex", flexDirection: "column" }} >
                        <div className={style.conditionInput}>
                            <div style={{ width: "100%" }}>
                                <div className={style.label}>
                                    <label >Name</label>
                                </div>
                                <Input
                                    disabled={lock}
                                    style={{ width: "100%", height: "44px", color: "#000610", fontSize: 15, border: nameCheck ? "1px solid #FF0000" : "1px solid #909BAD" }}
                                    value={name}
                                    placeholder="Enter Node Name"
                                    onChange={(e: any) => { setName(e.target.value); }}
                                />
                                {(nameCheck || !name) ? <p style={{
                                    color: "#FF0000",
                                    opacity: nameCheck || !name ? 1 : 0,
                                    position: "relative",
                                    margin: "5px",
                                    fontSize: 14
                                }}>{!name ? "Name shouldn't be empty" : "Name already exist"}</p> : <></>}
                            </div>
                        </div>
                        <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                    </div>
                    <div style={{ maxHeight: window.innerHeight - 410, overflow: "auto" }}>
                        <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px" }}>
                            <div
                                className={style.label}
                                style={{ color: "#3c434a" }}
                            >
                                <label >Next Node</label>
                            </div>
                            <Select
                                showSearch
                                onChange={(e: any) => setNextNode(e)}
                                suffixIcon={<Icon style={{ fontSize: "20px", margin: -5 }} type="caret-down" />}
                                disabled={lock}
                                value={nextNode || undefined}
                                placeholder="Select the next node"
                                optionLabelProp="label"
                                style={{
                                    width: "100%",
                                    borderRadius: 8,
                                    color: "#000610",
                                    fontSize: 15
                                }}
                                mode="default"
                                size="large"
                                filterOption={(input, option: any) => {
                                    return (option && option.props)
                                        ?
                                        option.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        : false
                                }}
                            >
                                {nodes && nodes.map((el: any) => {
                                    return <Option
                                        key={el.id}
                                        value={el.id}
                                        label={el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}>
                                        <div
                                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div
                                                style={{ display: "flex", flexDirection: "row" }}>
                                                <img alt="icons" src={el.data.icon} />
                                                <p
                                                    style={{
                                                        marginLeft: "8px",
                                                        marginTop: "14px",
                                                        color: el.id === nextNode ? "#0F66C8" : "#000610"
                                                    }}
                                                >
                                                    {el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                                </p>
                                            </div>
                                            {el.id === nextNode &&
                                                < Icon type="check" style={{ color: "#0F66C8" }} />}
                                        </div>
                                    </Option>
                                })}
                            </Select>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "5px 15px" }}>
                            <div className={style.label} >
                                <label> Waiting Form Screen</label>
                            </div>
                            <Select
                                showSearch
                                suffixIcon={<Icon style={{ fontSize: "20px", margin: "-5px" }} type="caret-down" />}
                                disabled={lock}
                                placeholder="Select the form"
                                value={selectedForm || undefined}
                                size="large"
                                style={{
                                    width: "100%",
                                    borderRadius: 8,
                                    //border: "1px solid #CAD5E9",
                                    color: "#000610",
                                    fontSize: 15,
                                }}
                                optionLabelProp="label"
                                onChange={(e: any) => setSelectedForm(e)}
                                filterOption={(input, option: any) => {
                                    return (option && option.props && option.children) ?
                                        option.children.children[0].children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        : false
                                }}
                            >
                                {form && form.map((item: any) => {
                                    return <Option
                                        key={item.formId}
                                        value={item.displayName}
                                        label={item.displayName}>
                                        <div
                                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <p style={{ marginTop: "10px", color: item.displayName === selectedForm ? "#0F66C8" : "#000610" }}>
                                                {item.displayName}
                                            </p>
                                            {item.displayName === selectedForm &&
                                                < Icon type="check" style={{ color: "#0F66C8" }} />}
                                        </div>
                                    </Option>
                                })}
                            </Select>
                        </div>
                        {loading && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingTop: '20px' }}><div className={moduleStyle.spinner}></div></div>}
                        {(inputVars?.length && !loading) ? <div>
                            <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px" }}>
                                <div
                                    className={style.label}
                                    style={{ color: "#3c434a" }}
                                >
                                    <label >Input Variables</label>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    {inputVars?.map((vars) => {
                                        return (
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                                                <Popover className="relative">
                                                    <Popover.Button style={{ background: 'none', border: 0, outline: 0, textAlign: 'left' }}>
                                                        <div
                                                            style={{ textDecoration: 'underline dashed', textUnderlineOffset: '4px', width: 115, color: "#000610", fontWeight: 500, fontSize: 14, textOverflow: "ellipsis", overflow: "hidden" }}
                                                        >
                                                            {required.includes(vars.key) ? <span style={{ color: 'red' }}>*</span> : <></>}
                                                            {vars.key}
                                                        </div>
                                                    </Popover.Button>

                                                    <Popover.Panel className="absolute z-10">
                                                        {({ close }) => (
                                                            <div className={style.inputPopover}>
                                                                <div className={style.headerPopover}>
                                                                    <div>
                                                                        <InfoSvg width={'16px'} height={'16px'} color='#475569' />
                                                                        <span className={style.onelineEllipsis} style={{ minWidth: 50, maxWidth: 150, color: '#334155', fontSize: 14, fontWeight: 600 }}>{vars.key}</span>
                                                                        <span style={{ borderRadius: '20px', color: '#6E747C', background: '#F0F0F0', padding: '2px 5px' }}>{vars.type}</span>
                                                                    </div>
                                                                    <CloseSvg style={{ cursor: 'pointer' }} onClick={() => { close() }} width={'14px'} height={'14px'} color='#94A3B8' />
                                                                </div>
                                                                {vars.desc && <div style={{ color: '#475569', fontSize: '12px', fontWeight: 400 }}>
                                                                    {vars.desc}
                                                                </div>}
                                                            </div>
                                                        )}
                                                    </Popover.Panel>
                                                </Popover>

                                                <Input
                                                    disabled={lock}
                                                    placeholder="Enter value" value={vars.value} style={{ height: 44, width: 186, border: "1px solid #909BAD", color: "#000610", fontSize: 14 }}
                                                    onChange={(e) => handleInputChange(vars.key, e.target.value)} />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div> : <></>}
                        <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                        <div>
                            <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px" }}>
                                <div
                                    className={style.label}
                                    style={{ color: "#3c434a" }}
                                >
                                    <label >Output Variables</label>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <Input
                                        disabled={lock}
                                        style={{ width: "100%", height: "44px", color: "#000610", fontSize: 15, border: "1px solid #909BAD" }}
                                        value={outputVariable}
                                        placeholder="Output variable"
                                        onChange={(e: any) => { setOutputVariable(e.target.value); }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                : <VariableAcl
                    variableAcl={variableAcl}
                    setVariableAcl={setVariableAcl}
                    teardownActiveTab={teardownActiveTab}
                    setTeardownActiveTab={setTeardownActiveTab}
                    setupActiveTab={setupActiveTab}
                    setSetupActiveTab={setSetupActiveTab}
                    setShowVariableAcl={setShowVariableAcl}
                    name={name}
                    lock={lock}>
                </VariableAcl>
            }
            {<div className={style.footer}>
                {!nameCheck && !lock && <Button
                    disabled={loading}
                    style={{
                        backgroundColor: "#51808C",
                        color: "#FFFFFF",
                        width: "100%",
                        height: 50
                    }}
                    onClick={() => { saveChanges() }} >APPLY</Button>}
            </div>}
        </>
    );
};

export default Action;
